// removed by extract-text-webpack-plugin
module.exports = {"exception":"exception___11iO2","imgBlock":"imgBlock___3dUZa","content":"content___3seTe","desc":"desc___1tjnS","actions":"actions___21Dlc"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Exception/index.less
// module id = 227
// module chunks = 0